// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Fade-in is driven entirely by CSS — the JS only toggles [data-loaded] once, and the
 * browser runs the rest on the compositor thread (GPU-accelerated opacity, no layout).
 *
 * The transition lives on the loaded state rather than the base one, so an image that is
 * already marked before its first paint has no earlier opacity to animate from and simply
 * appears. That is the case Image/index.tsx sets the attribute in the ref callback for:
 * a cached image is decoded before it is even attached, and fading it in would read as a
 * reload every time a virtualized row refills on scroll-back.
 *
 * An image still in flight is marked later, by onLoad, and does fade — there the gap is
 * real and the transition is what keeps it from snapping in.
 */
.U8aL0ZoxlHPI0rrC5EyU {
  opacity: 0;
}
.U8aL0ZoxlHPI0rrC5EyU[data-loaded] {
  opacity: 1;
  transition: opacity 0.12s ease-out;
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/Image/Image.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;EAYE;AACF;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,kCAAkC;AACpC","sourcesContent":["/*\n * Fade-in is driven entirely by CSS — the JS only toggles [data-loaded] once, and the\n * browser runs the rest on the compositor thread (GPU-accelerated opacity, no layout).\n *\n * The transition lives on the loaded state rather than the base one, so an image that is\n * already marked before its first paint has no earlier opacity to animate from and simply\n * appears. That is the case Image/index.tsx sets the attribute in the ref callback for:\n * a cached image is decoded before it is even attached, and fading it in would read as a\n * reload every time a virtualized row refills on scroll-back.\n *\n * An image still in flight is marked later, by onLoad, and does fade — there the gap is\n * real and the transition is what keeps it from snapping in.\n */\n.img {\n  opacity: 0;\n}\n.img[data-loaded] {\n  opacity: 1;\n  transition: opacity 0.12s ease-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"img": `U8aL0ZoxlHPI0rrC5EyU`
};
export default ___CSS_LOADER_EXPORT___;
